import { useState } from 'react';
import { theme, accentColor } from '../theme';
import type { AppItem } from '../api';

export function Card({ app, onOpen }: { app: AppItem; onOpen: (a: AppItem) => void }) {
  const [hover, setHover] = useState(false);
  const accent = accentColor(app.accent);
  const initials = app.glyph || app.name.slice(0, 2).toUpperCase();

  return (
    <button
      onClick={() => onOpen(app)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        textAlign: 'left',
        padding: 20,
        background: hover ? theme.surfaceHover : theme.surface,
        border: `1px solid ${hover ? accent : theme.line}`,
        borderRadius: 12,
        cursor: 'pointer',
        color: theme.text,
        fontFamily: 'inherit',
        transition: 'background 140ms, border-color 140ms, transform 140ms',
        transform: hover ? 'translateY(-1px)' : 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        minHeight: 116,
      }}
    >
      <div style={{
        width: 40, height: 40, borderRadius: 10,
        background: `${accent}22`, color: accent,
        display: 'grid', placeItems: 'center',
        fontWeight: 700, fontSize: 13, letterSpacing: '0.04em',
      }}>{initials}</div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: theme.text }}>{app.name}</div>
        {app.desc && (
          <div style={{
            fontSize: 12, color: theme.dim, lineHeight: 1.45,
            display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2,
            overflow: 'hidden',
          }}>{app.desc}</div>
        )}
      </div>
    </button>
  );
}
